import type { ReactNode } from "react";
import { cn, labels } from "./api";

export type Outcome = { action: string; value: number };

// Sorted from the worst to the best choice; null when every choice ends the same.
export function spectrumEdges(outcomes: Outcome[]) {
  const sorted = [...outcomes].sort((a, b) => a.value - b.value);
  return sorted.length && sorted[0].value !== sorted.at(-1)!.value
    ? { outcomes: sorted, worst: sorted[0], best: sorted.at(-1)! }
    : null;
}

// Every possible choice laid out from worst to best, with the chosen one marked.
export function ChoiceSpectrum({
  outcomes,
  mine,
  format,
  extra,
  footer,
}: {
  outcomes: Outcome[];
  mine?: string | null;
  format: (value: number) => string;
  extra?: (action: string) => ReactNode;
  footer?: ReactNode;
}) {
  const edge = spectrumEdges(outcomes);
  if (!edge)
    return (
      <p className="caption choice-spectrum-flat">
        이번 문제는 어떤 선택을 해도 결과가 같았어요.
      </p>
    );
  return (
    <div className="choice-spectrum">
      <ol aria-label="최악의 선택부터 최고의 선택까지">
        {edge.outcomes.map((o, n) => {
          const tone =
            o === edge.worst ? "worst" : o === edge.best ? "best" : "";
          return (
            <li
              key={o.action}
              data-tone={tone}
              className={mine === o.action ? "is-mine" : ""}
              style={{ animationDelay: `${n * 120}ms` }}
            >
              <small className="choice-spectrum-tag">
                {tone === "worst"
                  ? "최악의 선택"
                  : tone === "best"
                    ? "최고의 선택"
                    : " "}
              </small>
              <strong>{labels[o.action]}</strong>
              <span className={cn(o.value)}>{format(o.value)}</span>
              {extra?.(o.action)}
            </li>
          );
        })}
      </ol>
      {footer}
    </div>
  );
}
